import { useInstagramData, useInstagramWeeks } from 'utils/hooks';
import GraphNav from './GraphNav';
import { INSTAGRAM_SORT_OPTIONS } from 'utils/metrics';

const defaultSortOptions = [
    INSTAGRAM_SORT_OPTIONS.non_cum_avg_weekly_likes,
    INSTAGRAM_SORT_OPTIONS.non_cum_increase_WoW,
    INSTAGRAM_SORT_OPTIONS.non_cum_WoW,
    INSTAGRAM_SORT_OPTIONS.non_cum_increase_MoM_rolling,
    INSTAGRAM_SORT_OPTIONS.non_cum_MoM_rolling,
    INSTAGRAM_SORT_OPTIONS.non_cum_increase_QoQ_rolling,
    INSTAGRAM_SORT_OPTIONS.non_cum_QoQ_rolling,
    INSTAGRAM_SORT_OPTIONS.non_cum_increase_YoY_rolling,
    INSTAGRAM_SORT_OPTIONS.non_cum_YoY_rolling,
];

function InstagramGraphNav({ ids, countryId, categoryId, ...restProps }) {
    const { week, year, query: weeksQuery } = useInstagramWeeks();
    const dataQuery = useInstagramData({
        enabled: !!(ids?.length && countryId),
        countries: countryId ? [countryId] : null,
        categories: ids,
        paginateBy: 'categories',
    });
    const data = dataQuery.data;
    const isLoading =
        dataQuery.isLoading || weeksQuery.isLoading || !ids?.length;

    return (
        <GraphNav
            {...restProps}
            data={data}
            isLoading={isLoading}
            sortOptions={defaultSortOptions}
            primaryMetric={defaultSortOptions[0]}
            defaultSecondaryMetric={INSTAGRAM_SORT_OPTIONS.non_cum_YoY_rolling}
            week={week}
            year={year}
            categoryId={categoryId}
        />
    );
}

export default InstagramGraphNav;
